import MobileFullPage from './MobileFullPage';

export default MobileFullPage;
